import { render, staticRenderFns } from "./agentInstitution.vue?vue&type=template&id=07f78df9&scoped=true"
import script from "./agentInstitution.vue?vue&type=script&lang=js"
export * from "./agentInstitution.vue?vue&type=script&lang=js"
import style0 from "./agentInstitution.vue?vue&type=style&index=0&id=07f78df9&prod&lang=less"
import style1 from "./agentInstitution.vue?vue&type=style&index=1&id=07f78df9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f78df9",
  null
  
)

export default component.exports